import React from "react";
import styled from "styled-components";
import Image from "react-bootstrap/Image";

const Drivers = ({ data }) => (
  <Wrapper>
    <Image src="/cards/drivers.png" className="wrapper__background" />
    <div className="content">
      <div className="content__item content__image">
        <Image src={`data:image/png;base64, ${data?.picture}`} />
      </div>
      <p className="content__item content__name">
        {(data?.first_name || "") + " " + (data?.last_name || "")}
      </p>
      <p className="content__item content__date_of_birth">
        {data?.date_of_birth || ""}
      </p>
      <p className="content__item content__license">{data?.id_number || ""}</p>
      <p className="content__item content__class">
        {data?.class_of_license || ""}
      </p>
      <p className="content__item content__date_of_issue">
        {data?.registration_date || ""}
      </p>
      <p className="content__item content__nationality">
        {data?.nationality || ""}
      </p>
      <p className="content__item content__expiry">{data?.expiry_date || ""}</p>
      <p className="content__item content__reference">
        {data?.id_number || ""}
      </p>
    </div>
  </Wrapper>
);

const Wrapper = styled.div`
  width: 290px;
  height: 182px;
  position: relative;
  img.wrapper__background {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    position: absolute;
  }
  .content {
    width: 100%;
    height: 100%;
    position: relative;
    &__item {
      color: #000;
      font-size: 9px;
      font-weight: 600;
      position: absolute;
    }
    &__image {
      top: 64px;
      left: 11px;
      width: 70px;
      height: 80px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    &__name {
      top: 52px;
      left: 90px;
      font-size: 11px;
      text-transform: uppercase;
    }
    &__date_of_birth {
      top: 81px;
      left: 90px;
    }
    &__license {
      top: 81px;
      left: 192px;
    }
    &__class {
      top: 104px;
      left: 90px;
    }
    &__date_of_issue {
      top: 130px;
      left: 90px;
    }
    &__nationality {
      top: 130px;
      left: 210px;
    }
    &__expiry {
      top: 156px;
      left: 90px;
    }
    &__reference {
      top: 156px;
      left: 210px;
    }
  }
`;

export default Drivers;
